export default {
    product: {
        category: "קפה, תה ומשקאות", vatIncluded: "כולל מע״מ", add: "הוסף", added: "נוסף",
        favorite: "הוסף את {{name}} למועדפים", badgePitango: "מוצר פיטנגו", badgePopular: "פופולרי",
        detailTitle: "פרטי מוצר", priceUnavailable: "למחירים, פנו לשירות הלקוחות", bundleOffer: "{{quantity}} ב-{{price}}", percentOffer: "הנחה של {{percent}}%",
        callCustomerSupportForPrices: "למחירים, פנו לשירות הלקוחות", notFound: "המוצר לא נמצא"
    },
    cart: {
        title: "העגלה שלך", empty: "העגלה שלך ריקה", subtotal: "סכום ביניים", total: "סה״כ", shipping: "משלוח", shippingFree: "חינם",
        checkout: "המשך לתשלום", remove: "הסר את {{name}} מהעגלה", addedTitle: "נוסף לעגלה",
        addedMessage: "העגלה שלך עודכנה.", viewCart: "הצג עגלה", updateError: "לא הצלחנו לעדכן את העגלה. נסו שוב.",
        unitPrice: "מחיר רגיל: {{price}} ליחידה", promotion: "המבצע הופעל", bundleBreakdown: "מחיר מבצע × {{bundles}} · יחידות במבצע: {{units}}",
        remainderBreakdown: "{{units}} יחידות נוספות במחיר רגיל", discountedUnits: "הנחה על {{units}} יחידות",
        regularTotal: "ללא המבצע", youSave: "החיסכון שלך", itemTotal: "סה״כ לפריט",
        addMoreForPromotion: "הוסיפו עוד {{units}} כדי לקבל את מבצע {{offer}}.",
        promotionExtraCost: "בתוספת {{amount}} בלבד", promotionLowersTotal: "הסכום הכולל יקטן ב־{{amount}}",
        addPromotionUnits: "הוסיפו {{units}}"
    }
} as const;
